import { useQuery } from '@tanstack/react-query';
import { GetRolesResponseSchema, type GetRolesResponse, type RoleRef } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useRolesList() {
  const client = useApiClient();
  return useQuery<RoleRef[]>({
    queryKey: ['roles', 'list'],
    queryFn: async ({ signal }) => {
      const res = await client.get<GetRolesResponse>('/roles', { signal }, GetRolesResponseSchema);
      return res.items;
    },
  });
}
